import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing6});
`;

export const startTrialContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${MEDIA_MIN_SM} {
    flex-direction: row;
  }
`;

export const startTrialTextContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: var(${SpacingToken.Spacing3}) 0 var(${SpacingToken.Spacing1}) 0;

  ${MEDIA_MIN_SM} {
    margin: 0 0 0 var(${SpacingToken.Spacing4});
  }
`;

export const startTrialText = css`
  color: var(${DesignToken.ContentBasicPrimary});
  display: flex;
  flex-wrap: wrap;
  word-wrap: break-word;
  text-align: left;
  max-width: 272px;

  ${MEDIA_MIN_SM} {
    padding-right: var(${SpacingToken.Spacing5});
    min-width: 480px;
  }
`;

export const bottomText = css`
  color: var(${DesignToken.ContentBasicSecondary});
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  max-width: 272px;

  ${MEDIA_MIN_SM} {
    min-width: 440px;
    padding-right: var(${SpacingToken.Spacing5});
  }
`;

export const trialButton = css`
  min-width: fit-content;
  max-width: 200px;
  background-color: var(${DesignToken.DecorRed500});
  border: none;
  color: var(${DesignToken.ContentInvertPrimary});

  &:hover {
    background-color: var(${DesignToken.DecorRed600});
    color: var(${DesignToken.ContentInvertPrimary});
  }
`;

export const leftContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing2});

  ${MEDIA_MIN_SM} {
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
    max-width: 480px;
  }
`;

export const rightContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;

  ${MEDIA_MIN_SM} {
    width: auto;
    justify-content: center;
    align-items: center;
  }
`;
